import { withRouter, Link } from "react-router-dom"
import React, { useState } from "react"
import {
  Card,
  Button,
  CardBody,
  Row,
  Col,
  UncontrolledTooltip,
} from "reactstrap"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { CSVExport,Search } from "react-bootstrap-table2-toolkit"
import Select from "react-select"
import BootstrapTable from "react-bootstrap-table-next"
import { LargeModal } from "components/Common/LargeModal"
import { cardsData, getData } from "./data"
import * as moment from "moment"
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import TableLoader from "../../../components/Common/TableLoader";
import axios from "axios"
import {API_URL} from "../../../constants/constants"
import {SpribeLargeModal} from "../../../components/Common/SpribeLargeModal"

function Table(props) {
  const [isOpen, setIsOpen] = useState(false)
  const [spribeData, setSpribeData] = useState([]);

  let { data } = props

  data = data.sort((a, b) =>
      moment(a.created_at, "DD-MM-YYYY").isBefore(
          moment(b.created_at, "DD-MM-YYYY")
      )
          ? 1
          : -1
  )
  const columns = [
    {
      dataField: "id",
      text: "ID",
      sort: true,
      csvExport: true,
      csvFormatter: (cell, row) => row.id || ""
    },
    {
      dataField: "user.phone_number",
      text: "User Name",
      sort: true,
      csvExport: true,
      csvFormatter: (cell, row) => {
        return row.user && row.user.phone_number ? row.user.phone_number : "";
      }
    },
    {
      dataField: "Channel",
      text: "Channel",
      formatter: (cell, row) => <>{"Online"}</>,
      sort: true,
      csvExport: true,
      csvFormatter: () => "Online"
    },
    {
      dataField: "game.type.description",
      text: "Category",
      sort: true,
      csvExport: true,
      csvFormatter: (cell, row) => {
        return row.game && row.game.type && row.game.type.description 
          ? row.game.type.description 
          : "";
      }
    },
    {
      dataField: "game.game_name",
      text: "Product",
      sort: true,
      csvExport: true,
      csvFormatter: (cell, row) => {
        return row.game && row.game.game_name ? row.game.game_name : "";
      }
    },
    {
      dataField: "created_at",
      text: "Date Created",
      sort: true,
      formatter: (cell, row) => {
        const date = new Date(row?.created_at)
        const formattedDate = date.toLocaleString("en-GB", {
          timeZone: "CAT",
          hour12: true,
        })
        const capitalizedDate = formattedDate.replace(/(am|pm)/gi, match =>
          match.toUpperCase()
        )
        return <>{capitalizedDate}</>
      },
      csvExport: true,
      csvFormatter: (cell, row) => {
        if (!row.created_at) return "";
        try {
          const date = new Date(row.created_at)
          return date.toLocaleString("en-GB", {
            timeZone: "CAT",
            hour12: true,
          }).replace(/(am|pm)/gi, match => match.toUpperCase());
        } catch (e) {
          return row.created_at || "";
        }
      }
    },
    {
      dataField: "bets",
      text: "Bets",
      sort: true,
      formatter: (cell, row) => (
        <>{Number(row.bets ?? 1).toLocaleString("en-GB")}</>
      ),
      csvExport: true,
      csvFormatter: (cell, row) => {
        return row.bets ? Number(row.bets).toLocaleString("en-GB") : "1";
      }
    },
    {
      dataField: "amount",
      text: "Stake",
      sort: true,
      formatter: (cell, row) => (
        <>{Number(Number(row?.amount).toFixed(2)).toLocaleString("en-GB")}</>
      ),
      csvExport: true,
      csvFormatter: (cell, row) => {
        if (!row.amount) return "0.00";
        try {
          return Number(Number(row.amount).toFixed(2)).toLocaleString("en-GB");
        } catch (e) {
          return "0.00";
        }
      }
    },
    {
      dataField: "won_amount",
      text: "NetWin",
      sort: true,
      formatter: (cellContent, row) =>
        row.won_amount === null
          ? 0
          : Number(Number(row?.won_amount).toFixed(2)).toLocaleString("en-GB"),
      csvExport: true,
      csvFormatter: (cell, row) => {
        if (row.won_amount === null || row.won_amount === undefined) {
          return "0";
        }
        try {
          return Number(Number(row.won_amount).toFixed(2)).toLocaleString("en-GB");
        } catch (e) {
          return "0";
        }
      }
    },
    {
      dataField: "is_won",
      text: "Status",
      sort: true,
      formatter: (cellContent, row) =>
        row.is_won == 1 ? "won" : row.is_won == 0 ? "lost" : "pending",
      csvExport: true,
      csvFormatter: (cell, row) => {
        if (row.is_won == 1) return "won";
        if (row.is_won == 0) return "lost";
        return "pending";
      }
    },
  ];

  const Turbocolumns = [
    {
      dataField: "id",
      text: "ID",
      sort: true,
      // Add an exporter formatter to ensure ID is always exported
      csvExport: true,
      csvFormatter: (cell, row) => row.id || ""
    },
    {
      dataField: "user.phone_number",
      text: "User Name",
      sort: true,
      // Handle nested user data
      csvExport: true,
      csvFormatter: (cell, row) => {
        return row.user && row.user.phone_number ? row.user.phone_number : "";
      }
    },
    {
      dataField: "Channel",
      text: "Channel",
      formatter: (cell, row) => <>{"Online"}</>,
      sort: true,
      // Always export "Online" for Channel
      csvExport: true,
      csvFormatter: () => "Online"
    },
    {
      dataField: "game.name",
      text: "Product",
      sort: true,
      // Handle nested game data
      csvExport: true,
      csvFormatter: (cell, row) => {
        return row.game && row.game.name ? row.game.name : "";
      }
    },
    {
      dataField: "created_at",
      text: "Date Created",
      sort: true,
      formatter: (cell, row) => {
        const date = new Date(row?.created_at)
        const formattedDate = date.toLocaleString("en-GB", {
          timeZone: "CAT",
          hour12: true,
        })
        const capitalizedDate = formattedDate.replace(/(am|pm)/gi, match =>
          match.toUpperCase()
        )
        return <>{capitalizedDate}</>
      },
      // Format date the same way for CSV export
      csvExport: true,
      csvFormatter: (cell, row) => {
        if (!row.created_at) return "";
        try {
          const date = new Date(row.created_at)
          return date.toLocaleString("en-GB", {
            timeZone: "CAT",
            hour12: true,
          }).replace(/(am|pm)/gi, match => match.toUpperCase());
        } catch (e) {
          return row.created_at || "";
        }
      }
    },
    {
      dataField: "transactionId",
      text: "Transaction ID",
      sort: true,
      csvExport: true,
      csvFormatter: (cell, row) => row.transactionId || ""
    },
    {
      dataField: "bets",
      text: "Bets",
      sort: true,
      formatter: (cell, row) => (
        <>{Number(row?.bets ?? 1).toLocaleString("en-GB")}</>
      ),
      csvExport: true,
      csvFormatter: (cell, row) => {
        return row.bets ? Number(row.bets).toLocaleString("en-GB") : "1";
      }
    },
    {
      dataField: "stake",
      text: "Stake",
      sort: true,
      formatter: (cell, row) => (
        <>{Number(Number(row?.stake).toFixed(2)).toLocaleString("en-GB")}</>
      ),
      csvExport: true,
      csvFormatter: (cell, row) => {
        if (!row.stake) return "0.00";
        try {
          return Number(Number(row.stake).toFixed(2)).toLocaleString("en-GB");
        } catch (e) {
          return "0.00";
        }
      }
    },
    {
      dataField: "won_amount",
      text: "NetWin",
      sort: true,
      formatter: (cellContent, row) =>
        row.won_amount === null
          ? 0
          : Number(Number(row?.amount).toFixed(2)).toLocaleString("en-GB"),
      csvExport: true,
      csvFormatter: (cell, row) => {
        // Check which field to use: won_amount or amount
        const value = row.won_amount !== null && row.won_amount !== undefined 
          ? row.won_amount 
          : (row.amount || 0);
        
        try {
          return Number(Number(value).toFixed(2)).toLocaleString("en-GB");
        } catch (e) {
          return "0.00";
        }
      }
    },
    {
      dataField: "is_won",
      text: "Status",
      sort: true,
      formatter: (cellContent, row) =>
        row.resultType == "won"
          ? "won"
          : row.resultType == "lost"
          ? "lost"
          : "void",
      csvExport: true,
      csvFormatter: (cell, row) => {
        if (row.resultType === "won") return "won";
        if (row.resultType === "lost") return "lost";
        return "void";
      }
    },
  ];

  const Spribecolumns = [
    {
      dataField: "action_id",
      text: "ID",
      sort: true,
    },
    {
      dataField: "user.phone_number",
      text: "User Name",
      sort: true,
    },
    {
      dataField: "Channel",
      text: "Channel",
      formatter: (cell, row) => <>{"Online"}</>,
      sort: true,
      // Always export "Online" for Channel
      csvExport: true,
      csvFormatter: () => "Online"
    },
    {
      dataField: "game.name",
      text: "Product",
      sort: true,
    },
    {
      dataField: "created_at",
      text: "Date Created",
      sort: true,
      formatter: (cell, row) => (
          <>{" "}
            {new Date(Date.parse(row?.created_at)).toLocaleDateString('en-GB')}{" "}
            {new Date(Date.parse(row?.created_at)).toLocaleTimeString()}</>
      ),
    },
    // {
    //   dataField: "provider_tx_id",
    //   text: "Provider Tx Id",
    //   sort: true,
    //   // formatter: (cell, row) => <>{Number(row?.provider_tx_id ?? 1).toLocaleString('en-GB')}</>,
    // },
    {
      dataField: "stake",
      text: "Amount",
      sort: true,
      formatter: (cell, row) => <>{Number(Number(row?.stake).toFixed(2)).toLocaleString('en-GB')}</>,
    },
    {
      dataField: "win_amount",
      text: "NetWin",
      sort: true,
      formatter: (cellContent, row) =>
          row.won_amount === null ? 0 : Number(Number(row?.win_amount).toFixed(2)).toLocaleString('en-GB'),
    },
    {
      dataField: "platform",
      text: "Platform",
      sort: true,
    },

    // {
    //   dataField: "status",
    //   text: "Status",
    //   sort: true,
    //   formatter: (cellContent, row) =>
    //       (row.status == "200") ? ((row.request_type=='deposit' || row.request_type=='rollback') ? "won" : (row.request_type=='withdraw') ? "lost" : "pending") : "Pending",
    // },
  ]

  const modalColumns = [
    {
      dataField: "_id",
      text: "Id",
    },
    {
      dataField: "request_type",
      text: "Type",
      formatter: (cellContent, row) => (
        <>
          {row.request_type == "withdraw"
            ? "Bet"
            : row.request_type == "deposit"
            ? row.amount == 0
              ? "Lost"
              : "Won"
            : "Cancelled"}
        </>
      ),
    },
    {
      dataField: "amount",
      text: "Amount",
    },
    {
      dataField: "platform",
      text: "Platform",
    },
    {
      dataField: "session_token",
      text: "Session Token",
    },
    {
      dataField: "created_at",
      text: "Date Created",
      formatter: (cell, row) => {
        const date = new Date(row?.created_at)
        const formattedDate = date.toLocaleString("en-GB", {
          timeZone: "CAT",
          hour12: true,
        })
        const capitalizedDate = formattedDate.replace(/(am|pm)/gi, match =>
          match.toUpperCase()
        )
        return <>{capitalizedDate}</>
      },
    },
  ]

  const BinWinsColumns = [
    {
      dataField: "round_id",
      text: "ID",
      sort: true,
    },
    {
      dataField: "user.phone_number",
      text: "User Name",
      sort: true,
    },
    {
      dataField: "Channel",
      text: "Channel",
      formatter: (cell, row) => <>{"Online"}</>,
      sort: true,
      // Always export "Online" for Channel
      csvExport: true,
      csvFormatter: () => "Online"
    },
    {
      dataField: "game.name",
      text: "Product",
      sort: true,
    },
    {
      dataField: "created_at",
      text: "Date Created",
      sort: true,
      formatter: (cell, row) => (
          <>{" "}
            {new Date(Date.parse(row?.created_at)).toLocaleDateString('en-GB')}{" "}
            {new Date(Date.parse(row?.created_at)).toLocaleTimeString()}</>
      ),
    },
    // {
    //   dataField: "provider_tx_id",
    //   text: "Provider Tx Id",
    //   sort: true,
    //   // formatter: (cell, row) => <>{Number(row?.provider_tx_id ?? 1).toLocaleString('en-GB')}</>,
    // },
    {
      dataField: "stake",
      text: "Amount",
      sort: true,
      formatter: (cell, row) => (
        <>{Number(Number(row?.stake).toFixed(2)).toLocaleString("en-GB")}</>
      ),
    },
    {
      dataField: "win_amount",
      text: "NetWin",
      sort: true,
      formatter: (cellContent, row) =>
        row.won_amount === null
          ? 0
          : Number(Number(row?.win_amount).toFixed(2)).toLocaleString("en-GB"),
    },
    // {
    //   dataField: "platform",
    //   text: "Platform",
    //   sort: true,
    // },

    // {
    //   dataField: "status",
    //   text: "Status",
    //   sort: true,
    //   formatter: (cellContent, row) =>
    //       (row.status == "200") ? ((row.request_type=='deposit' || row.request_type=='rollback') ? "won" : (row.request_type=='withdraw') ? "lost" : "pending") : "Pending",
    // },
  ]

  const defaultSorted = [
    {
      dataField: "id",
      order: "desc",
    },
  ]
  const { SearchBar } = Search
  //pagination customization
  const { ExportCSVButton } = CSVExport;

  const pageOptions = {
    sizePerPage: 100,
    totalSize: data.length,
    custom: true,
  }

  const callAction = (id) => {
    axios({
      method: "get",
      url: `${API_URL}/admin/reports/action-spribe-list/${id}`,
    })
        .then(function (response) {
          // console.log(response?.data?.data)
          setSpribeData(response?.data?.data)
        })
        .catch(function (response) {
        })
  }

  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      if(props.type=="Spribe"){
        callAction(row.action_id)

        setIsOpen(true)
      }
    },
  }
  return (
    <>
      <Card>
        <CardBody>
          <div className="mb-4 h4 card-title">{"Games Tickets"}</div>
          {props.loadingMessage && props.loadingMessage == "1" ? (
            <TableLoader />
          ) : (
            <PaginationProvider
              pagination={paginationFactory(pageOptions)}
              keyField="id"
              columns={
                props.type === "TurboGames"
                  ? Turbocolumns
                  : props.type === "Spribe"
                  ? Spribecolumns
                  : props.type === "BigWins"
                  ? BinWinsColumns
                  : columns
              }
              data={data}
            >
              {({ paginationProps, paginationTableProps }) => (
                <ToolkitProvider
                  keyField="id"
                  data={data}
                  columns={
                    props.type === "TurboGames"
                      ? Turbocolumns
                      : props.type === "Spribe"
                      ? Spribecolumns
                      : props.type === "BigWins"
                      ? BinWinsColumns
                      : columns
                  }
                  bootstrap4
                  search
                  exportCSV={{
                    onlyExportFiltered: true,
                    exportAll: false,
                    fileName: `Games-Tickets-${moment(new Date()).format(
                      "DD/MM/YYYY"
                    )}.csv`,
                  }}
                >
                  {toolkitProps => (
                    <React.Fragment>
                      <Row className="mb-2">
                        <Col sm="6">
                          <Row>
                            <Col sm="6">
                              <div className="search-box me-2 mb-2 d-inline-block">
                                <div className="position-relative">
                                  <SearchBar {...toolkitProps.searchProps} />
                                  <i className="bx bx-search-alt search-icon" />
                                </div>
                              </div>
                            </Col>
                            <Col sm="6">
                              <div>
                                <ExportCSVButton
                                  {...toolkitProps.csvProps}
                                  className="download-table-xls-button w-md btn btn-primary"
                                >
                                  Download
                                </ExportCSVButton>
                              </div>
                            </Col>
                          </Row>
                        </Col>
                        <Col sm={6}></Col>
                      </Row>
                      <Row>
                        <Col xl="12">
                          <div className="table-responsive">
                            <BootstrapTable
                              id="table-to-xls"
                              keyField="id"
                              responsive
                              bordered={false}
                              striped={false}
                              defaultSorted={defaultSorted}
                              //   selectRow={selectRow}
                              classes={
                                "table align-middle table-nowrap table-check"
                              }
                              headerWrapperClasses={"table-light"}
                              {...toolkitProps.baseProps}
                              {...paginationTableProps}
                              rowClasses={"mytable-hover-row"}
                              rowEvents={rowEvents}
                            />
                          </div>
                        </Col>
                      </Row>
                      <div className="pagination pagination-rounded justify-content-end">
                        <PaginationListStandalone {...paginationProps} />
                      </div>
                    </React.Fragment>
                  )}
                </ToolkitProvider>
              )}
            </PaginationProvider>
          )}
        </CardBody>
      </Card>
      {Object.keys(spribeData).length !== 0 ? (
        <SpribeLargeModal
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          cardsData={cardsData}
          betType={"1bet, 2-fold multiple"}
          size={"xl"}
          columns={modalColumns}
          data={spribeData}
        />
      ) : (
        ""
      )}
    </>
  )
}

export default Table